import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import { setCookie, delCookie, getCookie } from "./cookie";

Vue.use(Vuex)
let token = getCookie('token_pc')
let isLogin = token ? true : false
export default new Vuex.Store({
  state: {
    isLogin,
    token,
    keywords: '',
    progress: 0
  },
  mutations: {
    LOG_IN(state, { token = ''}) {
      console.log(token);
      state.isLogin = true
      state.token = token
      setCookie('token_pc', token)
      router.push({name: 'index'})
    },
    LOG_OUT(state) {
      delCookie('token_pc')
      state.token = ''
      state.isLogin = false
      router.push({name: 'login'})
    },
    CHANGE_KEYWORDS(state, keywords) {
      state.keywords = keywords
    },
    SET_PROGRESS(state, progress) {
      // console.log('complete =  ',progress)
      if(progress >= 100) {
        setTimeout(() => {
          state.progress = 0
        }, 200);
      } else if(state.progress < progress) {
        state.progress = progress
      }
    },
  }
})